import LocationMap from "./LocationMap";

export default LocationMap;
